import { Box, Dialog, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { FirstTimeTour } from 'src/constants/productTour/FirstTimeTour';
import {
  reducerResetTourSteps,
  reducerUpdateNextTourSteps,
  reducerUpdateOnTour
} from 'src/features/productTour';
import { reducerUpdateSelectedIds } from 'src/features/sosmedComparison';
import { SOCIAL_MEDIA_COMPARISON } from 'src/route';

export default function ModalProductTour() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { stepNumber, totalStep, currentStep, menu, submenu } = useAppSelector(
    (state) => state.storeProductTour.currentTour
  );

  return (
    <Dialog
      open={
        stepNumber === 1 ||
        (stepNumber > 0 &&
          stepNumber === totalStep &&
          menu !== FirstTimeTour.menu)
      }
      fullWidth
      maxWidth={'sm'}
    >
      <Stack sx={{ padding: '16px' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography fontWeight="bold">{currentStep.title}</Typography>
          <Typography
            color="#9D9D9C"
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              dispatch(reducerUpdateOnTour(false));
              dispatch(reducerResetTourSteps());
              localStorage.removeItem('isFirstTime');
            }}
          >
            x
          </Typography>
        </Stack>
        {currentStep.content}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={1}
          sx={{ marginTop: '12px' }}
        >
          {currentStep.showNextButton ? (
            <Box
              sx={{
                backgroundColor: '#0B85AE',
                padding: '8px',
                cursor: 'pointer',
                borderRadius: '4px',
                '&:hover': {
                  opacity: 0.5
                }
              }}
              onClick={() => {
                if (stepNumber === 1) {
                  dispatch(reducerUpdateNextTourSteps());
                } else {
                  if (menu === 'social-media' && submenu === 'comparison') {
                    dispatch(
                      reducerUpdateSelectedIds({
                        comparisonCategory: 'object',
                        values: []
                      })
                    );
                    navigate(SOCIAL_MEDIA_COMPARISON);
                  }
                  dispatch(reducerUpdateOnTour(false));
                  dispatch(reducerResetTourSteps());
                  localStorage.removeItem('isFirstTime');
                }
              }}
            >
              <Typography fontSize="12px" fontWeight="600" color="white">
                {currentStep.nextButtonText}
              </Typography>
            </Box>
          ) : (
            <div></div>
          )}
          <Typography color="#9D9D9C" fontSize="12px">
            {stepNumber}/{totalStep}
          </Typography>
        </Stack>
      </Stack>
    </Dialog>
  );
}
